function createShareUrl() {
  return `https://signal.org/download/`
}

export default {
  id: 'signal',
  title: 'Signal',
  createShareUrl
}
